<div class="disclaimer-container"  [ngClass]="(alert) ? 'alert' : ''" >
    <div class="disclaimer-layout">
        <img src="../../../../../assets/icons/exclamation.svg" class="img-icon">
        <div>
            <p class="disclaimer-text">Fecha de publicación de la factura: <span class="label-black">{{ date }}</span></p>
        </div>
    </div>
</div>